var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvl3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_11)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#1FAA38",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26289 30.92H14.1429V33H7.18289V19.14H9.26289V30.92ZM19.2648 33H18.1648L13.9448 23.7H16.0848L18.7248 30.14L21.4048 23.7H23.5048L19.2648 33ZM26.3918 33H24.4118V19.14H26.3918V33ZM33.6999 21.06C34.0866 20.38 34.5999 19.8267 35.2399 19.4C35.8799 18.9733 36.5799 18.76 37.3399 18.76C37.8733 18.76 38.3799 18.86 38.8599 19.06C39.3399 19.26 39.7599 19.5333 40.1199 19.88C40.4799 20.2133 40.7666 20.6133 40.9799 21.08C41.1933 21.5333 41.2999 22.02 41.2999 22.54C41.2999 23.1533 41.1333 23.7 40.7999 24.18C40.4799 24.66 40.0599 25.0133 39.5399 25.24C39.9799 25.36 40.3533 25.5467 40.6599 25.8C40.9799 26.04 41.2333 26.3267 41.4199 26.66C41.6199 26.98 41.7666 27.3333 41.8599 27.72C41.9533 28.0933 41.9999 28.4667 41.9999 28.84C41.9999 29.4667 41.8733 30.0467 41.6199 30.58C41.3799 31.1133 41.0466 31.58 40.6199 31.98C40.2066 32.38 39.7133 32.6933 39.1399 32.92C38.5799 33.1467 37.9799 33.26 37.3399 33.26C36.4199 33.26 35.5999 33.0333 34.8799 32.58C34.1599 32.1267 33.5866 31.5133 33.1599 30.74L34.7599 29.3C35.0399 29.86 35.3999 30.3133 35.8399 30.66C36.2799 31.0067 36.7799 31.18 37.3399 31.18C37.6999 31.18 38.0399 31.12 38.3599 31C38.6799 30.8667 38.9533 30.6933 39.1799 30.48C39.4066 30.2533 39.5866 30 39.7199 29.72C39.8533 29.4267 39.9199 29.12 39.9199 28.8C39.9199 28.0267 39.6799 27.4067 39.1999 26.94C38.7333 26.4733 38.0399 26.24 37.1199 26.24H36.3399V24.5H37.1199C37.7733 24.5 38.2799 24.3333 38.6399 24C39.0133 23.6533 39.1999 23.18 39.1999 22.58C39.1999 22.1133 39.0266 21.7133 38.6799 21.38C38.3466 21.0467 37.8999 20.88 37.3399 20.88C36.4733 20.88 35.8266 21.3933 35.3999 22.42L33.6999 21.06Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl3);
export default __webpack_public_path__ + "static/media/lvl3.ef7e21c5374954006700472d67a283af.svg";
export { ForwardRef as ReactComponent };